import {
  hyphenate,
  //hyphenateHTML,
  //hyphenateHTMLSync,
  //hyphenateSync
} from "hyphen/is";

const HyphenText = {

  init: () => {
    var detailsHeader = document.querySelectorAll('.hyphenHeader');

    for (let i = 0; i < detailsHeader.length; i++) {
      var detailsHeaderItem = detailsHeader[i];
      hyphenate(detailsHeaderItem.innerHTML).then(result => {
        detailsHeaderItem.innerHTML = result;
      });
    }
  },
};

export default HyphenText;
